<template>
  <div>
      <b-container fluid style="padding-top: 100px;">
        <b-row>
          <b-col cols="12"><HeaderFixed/></b-col>
        </b-row>
      <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                  <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                    Home
                    </router-link>
                </b-breadcrumb-item>
                <b-breadcrumb-item href="#home">
                  <router-link to="/Gallery">
                    Gallery
                    </router-link>
                </b-breadcrumb-item>

               <b-breadcrumb-item href="#" active>Sub Gallery</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
          <b-col cols="12">
            <span class="title">Gallery</span>
          </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div id="gal">
            <Tinybox v-model="index" :images="images"></Tinybox>
              <b-row >
                <b-col cols="2"  v-for="(img, idx) in images">
                  <img
                   :src="img.thumbnail"
                   :alt="img.alt"
                   class="open-tinybox thumb"
                   @click="index = idx"
                  >
                  <br>
                  <span align="center">{{ img.caption }}</span>
                </b-col>
            </b-row>
          </div>
      </b-col>
    </b-row>
    </b-container>
  </div>
</template>

<style>
.thumb{
  height:120px;
  width:90%;
  margin-top:40px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.5s ease;
}
.thumb:hover
{
  /* transform: rotate(20deg); */
  transform: scale(1.12) rotate(-8deg);
}
.tinybox
{
  top:100px !important;
}

</style>
<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
export default({
  components: {
    'HeaderFixed' : HeaderFixed
    },

  data() {
    return {
      images: [
        {
          src: require("../assets/bg1.jpg"),
          alt: "Alt 1",
          thumbnail: require("../assets/bg1.jpg"),
          caption: "Sunset-1"

        },
        {
          src: require("../assets/bg2.jpg"),
          alt: "Alt 2",
          thumbnail: require("../assets/bg2.jpg"),
          caption: "Sunset-2"
        },
        {
          src: require("../assets/bg3.jpg"),
          alt: "Alt 3",
          thumbnail: require("../assets/bg3.jpg"),
          caption: "Sunset-3"
        },
        {
          src: require("../assets/bg1.jpg"),
          alt: "Alt 1",
          thumbnail: require("../assets/bg1.jpg"),
          caption: "Sunset-1"

        },
        {
          src: require("../assets/bg2.jpg"),
          alt: "Alt 2",
          thumbnail: require("../assets/bg2.jpg"),
          caption: "Sunset-2"
        },
        {
          src: require("../assets/bg3.jpg"),
          alt: "Alt 3",
          thumbnail: require("../assets/bg3.jpg"),
          caption: "Sunset-3"
        },
        {
          src: require("../assets/bg1.jpg"),
          alt: "Alt 1",
          thumbnail: require("../assets/bg1.jpg"),
          caption: "Sunset-1"

        },
        {
          src: require("../assets/bg2.jpg"),
          alt: "Alt 2",
          thumbnail: require("../assets/bg2.jpg"),
          caption: "Sunset-2"
        },
        {
          src: require("../assets/bg3.jpg"),
          alt: "Alt 3",
          thumbnail: require("../assets/bg3.jpg"),
          caption: "Sunset-3"
        },
        {
          src: require("../assets/bg1.jpg"),
          alt: "Alt 1",
          thumbnail: require("../assets/bg1.jpg"),
          caption: "Sunset-1"

        },
        {
          src: require("../assets/bg2.jpg"),
          alt: "Alt 2",
          thumbnail: require("../assets/bg2.jpg"),
          caption: "Sunset-2"
        },
        {
          src: require("../assets/bg3.jpg"),
          alt: "Alt 3",
          thumbnail: require("../assets/bg3.jpg"),
          caption: "Sunset-3"
        },
        {
          src: require("../assets/bg1.jpg"),
          alt: "Alt 1",
          thumbnail: require("../assets/bg1.jpg"),
          caption: "Sunset-1"

        },
        {
          src: require("../assets/bg2.jpg"),
          alt: "Alt 2",
          thumbnail: require("../assets/bg2.jpg"),
          caption: "Sunset-2"
        },
        {
          src: require("../assets/bg3.jpg"),
          alt: "Alt 3",
          thumbnail: require("../assets/bg3.jpg"),
          caption: "Sunset-3"
        }
      ],
      index: null
    }
  }
});
</script>
